export default "__VITE_ASSET__Oi6NqqWK__"